<template>
  <div >

    <div id="choices3">
      <h3>Auswahl</h3>
      <draggable
        class="list-group"
        :list="options"
        group="people"
        @change="log"
        itemKey="name"
      >
        <template #item="{ element }">
          <div class="list-group-item">{{ element.name }}</div>
        </template>
      </draggable>
    </div>

    <div id = "slot10" class="slots">
      <h3>Slot1</h3>
      <draggable
        class="list-group"
        :list="list10"
        group="people"
        @change="log"
        itemKey="name"
      >
        <template #item="{ element }">
          <div class="list-group-item">{{ element.name }}</div>
        </template>
      </draggable>
    </div>

    <div id = "slot11" class="slots">
      <h3>Slot2</h3>
      <draggable
        class="list-group"
        :list="list11"
        group="people"
        @change="log"
        itemKey="name"
      >
        <template #item="{ element}">
          <div class="list-group-item">{{ element.name }}</div>
        </template>
      </draggable>
    </div>

    <div id = "slot12" class="slots">
      <h3>Slot3</h3>
      <draggable
        class="list-group"
        :list="list12"
        group="people"
        @change="log"
        itemKey="name"
      >
        <template #item="{ element}">
          <div class="list-group-item">{{ element.name }}</div>
        </template>
      </draggable>
    </div>

    <div id = "slot13" class="slots">
      <h3>Slot4</h3>
      <draggable
        class="list-group"
        :list="list13"
        group="people"
        @change="log"
        itemKey="name"
      >
        <template #item="{ element}">
          <div class="list-group-item">{{ element.name }}</div>
        </template>
      </draggable>
    </div>

    <div id = "slot14" class="slots">
      <h3>Slot5</h3>
      <draggable
        class="list-group"
        :list="list14"
        group="people"
        @change="log"
        itemKey="name"
      >
        <template #item="{ element}">
          <div class="list-group-item">{{ element.name }}</div>
        </template>
      </draggable>
    </div>

    <!-- <rawDisplayer class="col-3" :value="list1" title="List 1" /> -->

    <!-- <rawDisplayer class="col-3" :value="list2" title="List 2" /> -->
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,
  components: {
    draggable
  },
  data() {
    return {
      options: [
        { name: "Schwingspule", id: 1 },
        { name: "Sicke", id: 2 },
        { name: "Polplatten", id: 3 },
        { name: "Membran", id: 4 },
        { name: "Abdeckklappe", id: 5 },
        
        

      ],
      list10: [],
      list11: [],
      list12: [],
      list13: [],
      list14: [],
    };
  },
  methods: {
    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function(evt) {
      window.console.log(evt);
    },
    test: function() {
      // alert(this.list2);
      if ( (this.list10[0] && this.list10[0].name == "Sicke") &&
           (this.list11[0] && this.list11[0].name == "Membran") &&
           (this.list12[0] && this.list12[0].name == "Abdeckklappe") &&
           (this.list13[0] && this.list13[0].name == "Polplatten") &&
           (this.list14[0] && this.list14[0].name == "Schwingspule") 
         ){
          alert("richtig");
          this.$store.commit('setTaskCompletionState', {varname: "audioDnD3_done", state: true})
          localStorage.setItem("audioDnD3_done", true);
          // console.log("setItem: marked Task 1 as false?" + localStorage.getItem("task1done"))
         }
      else {
        alert("falsch")
      }

      
    }
  }
};
</script>

<style scoped>
.slots {
  background-color: lightgrey;
  width: 150px;
  position: absolute;
}
#choices3 {
  position: absolute;
  width: 150px;
  left: 1100px;
  top: 150px
}
#slot10 {
  top: 160px;
  left: 440px;
}
#slot11 {
  top: 220px;
  left: 540px;
}
#slot12 {
  top: 270px;
  left: 650px;
}
#slot13 {
  top: 410px;
  left: 890px;
}
#slot14 {
  top: 490px;
  left: 488px;
}

#app .main-container {
  padding-top: 40px;
}
.main-application {
  width: 400px;
}
.jumbotron.logo {
  text-align: center;
  padding-top: 32px;
  padding-bottom: 16px;
}
.jumbotron.logo .draggable {
  height: 200px;
}
.row.icon-container {
  justify-content: space-between;
  flex-direction: row;
  padding-bottom: 15px;
  margin-left: 0;
}
a.github {
  color: black;
  float: left;
}
.icon i {
  font-size: 20px;
}
a {
  color: black;
}
#badges {
  text-align: center;
  padding: 10px;
}
#badges img {
  padding-left: 2px;
  padding-right: 2px;
}
#tab-content {
  min-height: 500px;
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}
.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>